import classes from '@/components/Shares/Table.module.css';
import { useLingui } from '@lingui/react';
import { Table, rem } from '@mantine/core';
import { session } from './data';
export const SecuritySessionTable: React.FC = () => {
  const {
    i18n
  } = useLingui();
  const rows = session.map(row => <Table.Tr key={row.id} h={46} fz={12} c="var(--text-dark)">
      <Table.Td>{row.browser}</Table.Td>
      <Table.Td>{row.near}</Table.Td>
      <Table.Td visibleFrom="sm">{row.ip}</Table.Td>
      <Table.Td>{row.lastUse}</Table.Td>
      <Table.Td visibleFrom="sm">{row.action}</Table.Td>
    </Table.Tr>);
  const ths = <Table.Tr fz={rem(12)}>
      <Table.Th>{i18n._('Browser')}</Table.Th>
      <Table.Th>{i18n._('Near')}</Table.Th>
      <Table.Th visibleFrom="sm">{i18n._('Ip address')}</Table.Th>
      <Table.Th>{i18n._('Last used')}</Table.Th>
      <Table.Th visibleFrom="sm">{i18n._('Action')}</Table.Th>
    </Table.Tr>;
  return <Table.ScrollContainer minWidth={300}>
      <Table striped classNames={classes}>
        <Table.Thead>{ths}</Table.Thead>
        <Table.Tbody>{rows}</Table.Tbody>
      </Table>
    </Table.ScrollContainer>;
};